import { actionTypes } from '../actions';

const initialState = {
  name: '',
  eventID: 0,
  competition: 0,

  distance1Type: '',
  distance1Value: 0,
  distance1StartOffset: 0,

  distance2Type: '',
  distance2Value: 0,
  distance2StartOffset: 0,

  distance3Type: '',
  distance3Value: 0,
  distance3StartOffset: 0,

  /*
   * Offsets de largada por categoría.
   *
   * Utilizado por:
   *
   * - Triatlón
   * - Duatlón
   * - Rural Bike / MTB
   *
   * Estructura:
   *
   * [
   *   {
   *     catCod: 'CAB PRO',
   *     catName: 'CPRO',
   *     offset: 0
   *   }
   * ]
   */
  categoryStartOffsets: [],

  showResultsDistance1: false,
  showResultsLocales: false,
  date: '',
  place: '',
  sendSMS: false,
  beep: false,
  interval: 10,
  prefix: '',
  totals: 0
};


export default function (state = initialState, action) {
  switch (action.type) {

    case actionTypes.REGISTER_INFO:
      return {
        ...state,

        name: action.name,
        eventID: action.eventID,
        competition: action.competition,

        distance1Type: action.distance1Type,
        distance1Value: action.distance1Value,
        distance1StartOffset: action.distance1StartOffset,

        distance2Type: action.distance2Type,
        distance2Value: action.distance2Value,
        distance2StartOffset: action.distance2StartOffset,

        distance3Type: action.distance3Type,
        distance3Value: action.distance3Value,
        distance3StartOffset: action.distance3StartOffset,

        categoryStartOffsets:
          Array.isArray(
            action.categoryStartOffsets
          )
            ? action.categoryStartOffsets
            : [],

        showResultsDistance1: action.showResultsDistance1,
        showResultsLocales: action.showResultsLocales,
        date: action.date,
        place: action.place,
        sendSMS: action.sendSMS,
        beep: action.beep,
        interval: action.interval,
        prefix: action.prefix
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer-register-info.js